export enum PACKING_SLIP_TRANSLATION_KEYS {
    PACKING_SLIP_FOR_RMA = 'PACKING_SLIP_FOR_RMA',
    ORDER_ID = 'ORDER_ID',
    ORDER_ID_BARCODE = 'ORDER_ID_BARCODE',
    WAREHOUSE_RMA_ID = 'WAREHOUSE_RMA_ID',
    WAREHOUSE_RMA_ID_BARCODE = 'WAREHOUSE_RMA_ID_BARCODE',
    SHIP_TO = 'SHIP_TO',
    SENT_BY = 'SENT_BY',
    IMAGE = 'IMAGE',
    PRODUCT_NAME = 'PRODUCT_NAME',
    VARIANT = 'VARIANT',
    SKU = 'SKU',
    PRICE = 'PRICE',
    RETURN_REASON = 'RETURN_REASON',
    PACKING_SLIP_INSTRUCTIONS = 'PACKING_SLIP_INSTRUCTIONS',
    ADDRESS_SLIP_INSTRUCTIONS = 'ADDRESS_SLIP_INSTRUCTIONS'
}